export const metaTags = {
  metaTitle: "All Auctions",
  metaDescription:
    "Auctions, Buy Now, Make an Offer - BIDS.COM Engagement Rings, Gold and Diamond Jewelry, Jewellery, Watches, Designer Bags, Clothing, Shoes, Sunglasses, Accessories, Arts Ring - Necklace - Earrings - Panting - Watches - Shoes - Clothing - Sunglasses - Accessories - Bags Free Shipping and Discount Options Available",
  image:
    "https://cdn.shopify.com/s/files/1/0071/2081/4195/products/main_050e6db5-dc15-47b8-9bad-14d600333819_600x600_crop_center.jpg?v=1565936416",
};
